// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"22be2935","787":"36a1923c","825":"7d4261a9"}[chunkId] + ".chunk.js";
};